import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ExpertDismissedSuggestedActionEventProperties {
  lead_id: string
  suggested_action_type: string
  suggested_action_display_name: string
}

export class ExpertDismissedSuggestedActionEvent extends Event<
  ExpertDismissedSuggestedActionEventProperties
> {
  static displayName = 'Expert Dismissed Suggested Action'

  static allowedIdentities = [Identity.BusinessUser]
}
